// French UI strings (tender row 7): same keys as en_US.js, translated from its English values (scripts/i18n/fr_values.txt).
const frMessages = {
    "Terminal Programları": "Programmes terminal",
    "Kabul ve Giriş": "Réception et entrée",
    "PDI ve Saha": "PDI et parc",
    "Sevkiyat ve Çıkış": "Expédition et sortie",
    "Kontrol ve Yardımcı İşlemler": "Contrôles et outils",
    "menu.KullaniciVeRolYonetimi": "Gestion des utilisateurs et des rôles",
    "menu.KullaniciYonetimi": "Gestion des utilisateurs",
    "menu.KullaniciRolYonetimi": "Gestion des rôles utilisateur",
    "menu.YetkiGrupYonetimi": "Gestion des groupes d'autorisations",
    "1- Araç Sorgulama": "1- Recherche de véhicule",
    "2- Liman Giriş": "2- Entrée au port",
    "3- Limandan Depoya Sevkiyat": "3- Expédition du port vers l'entrepôt",
    "4- Tekli Grupaj Tır Eşleme": "4- Affectation camion à un groupage",
    "5- Depolar Arası Transfer": "5- Transfert entre entrepôts",
    "6- Depo Giriş": "6- Entrée en entrepôt",
    "7- Gemi Araç Giriş": "7- Entrée des véhicules du navire",
    "8- Antrepo Çıkış": "8- Sortie d'entrepôt sous douane",
    "9- PDI Giriş": "9- Entrée PDI",
    "10- PDI Dönüş": "10- Retour PDI",
    "11- PDI Yapılmayacak": "11- PDI non requis",
    "12- Gümrüklü Alan'a İade": "12- Retour en zone sous douane",
    "13- PDI Çıkış": "13- Sortie PDI",
    "14- Hasarlıdan Çıkış": "14- Sortie de la zone endommagés",
    "15- Sevk Alanına Transfer": "15- Transfert vers la zone d'expédition",
    "16- Peron Kontrol": "16- Contrôle de quai",
    "17- Şase İle Kapı Çıkış": "17- Sortie de châssis par le portail",
    "18- Tır Onay": "18- Validation du camion",
    "19- Depo Çıkış": "19- Sortie d'entrepôt",
    "20- Otomatik Adres Değiştir": "20- Changement d'adresse automatique",
    "21- Yerinde Adresleme": "21- Adressage sur place",
    "22- Sayım": "22- Inventaire",
    "23- Yazıcı Seçimi": "23- Choix de l'imprimante",
    "24- Etiket Yazdır": "24- Imprimer l'étiquette",
    "sifremiDegistir": "Changer mon mot de passe",
    "cikisYap": "Déconnexion",
    "Araç Bilgileri": "Informations véhicule",
    "Giriş-Çıkış Tarihleri": "Dates d'entrée-sortie",
    "Araç Hareketleri": "Mouvements du véhicule",
    "Emirler": "Ordres",
    "Sevkiyet Hareketleri": "Mouvements d'expédition",
    "Hasarlar": "Dommages",
    "Blokaj": "Blocage",
    "Tarihçe": "Historique",
    "Şase": "VIN",
    "Bul": "Rechercher",
    "Marka": "Marque",
    "Model": "Modèle",
    "PDI Durumu": "Statut PDI",
    "Fatura Tarih": "Date de facture",
    "Fatura No": "N° de facture",
    "Fatura Bayi": "Concessionnaire facturé",
    "Millileşme Durumu": "Statut de dédouanement",
    "Park Adres": "Adresse de parc",
    "Noas Ref": "Réf. Noas",
    "Durum": "Statut",
    "Son Yapılan İşlem Tarihi": "Date de la dernière opération",
    "Son Hareket Tarihi": "Date du dernier mouvement",
    "Renk": "Couleur",
    "Son İşlem": "Dernière opération",
    "Son Hareket": "Dernier mouvement",
    "No Data": "Aucune donnée",
    "Türkiye Liman Giriş": "Entrée port Turquie",
    "Türkiye Liman Çıkış": "Sortie port Turquie",
    "Liman Giriş": "Entrée portuaire",
    "Liman Çıkış": "Sortie portuaire",
    "Antrepo Transfer Emri": "Ordre de transfert d'entrepôt sous douane",
    "T1 Belgesi (Transit)": "Document T1 (Transit)",
    "IM7 (Antrepo Giriş)": "IM7 (Entrée sous douane)",
    "Evrak Yönetimi": "Gestion des documents",
    "Antrepo Giriş": "Entrée fictive",
    "Antrepo Çıkış": "Sortie fictive",
    "Son Depo Giriş": "Dernière entrée en entrepôt",
    "Son Depo Çıkış": "Dernière sortie d'entrepôt",
    "Şase Sorgulama": "Recherche VIN",
    "Tarih": "Date",
    "Hareket Tipi": "Type de mouvement",
    "HareketKodu": "Code mouvement",
    "HareketAdı": "Nom du mouvement",
    "Nereden": "De",
    "Nereye": "Vers",
    "BulunduguAdres": "Adresse actuelle",
    "GittigiYer": "Destination",
    "ParkSoforu": "Chauffeur de parc",
    "IslemYapanKullanici": "Utilisateur",
    "Giriş Tarih": "Date d'entrée",
    "Gerçekleşme": "Réalisation",
    "Emir Kodu": "Code ordre",
    "Emir Adı": "Nom de l'ordre",
    "Emir Durumu": "Statut de l'ordre",
    "Emir Oluşturan": "Créateur de l'ordre",
    "GrupajNo": "N° de groupage",
    "Rota": "Itinéraire",
    "Grupaj Tarih": "Date du groupage",
    "Kapı Çıkış Tarih": "Date de sortie portail",
    "Taşıyıcı": "Transporteur",
    "Tır Plaka": "Plaque du camion",
    "Şoför": "Chauffeur",
    "Grupaj Statü": "Statut du groupage",
    "Fatura Tarihi": "Date de facture",
    "Hasar Giriş": "Saisie de dommage",
    "İşlem Tarihi": "Date de l'opération",
    "Hasar Yeri": "Emplacement du dommage",
    "Hasar Detay": "Détail du dommage",
    "Hasar Sorumlusu": "Responsable du dommage",
    "Hasar Durumu": "Statut du dommage",
    "Kaydı Oluşturan": "Créé par",
    "Blokaj No": "N° de blocage",
    "Blokaj Açıklama": "Description du blocage",
    "Aktif/Pasif": "Actif/Passif",
    "Kodlama Tarihi": "Date de codage",
    "Kodlayan": "Codé par",
    "Kaldırma Tarihi": "Date de levée",
    "İptal Eden": "Annulé par",
    "Dosya Adı": "Nom du fichier",
    "Yükleme Tarih": "Date de chargement",
    "Yükleyen": "Chargé par",
    "Durum Kodu": "Code statut",
    "Durum Açıklama": "Description du statut",
    "Olay Adı": "Nom de l'événement",
    "Operasyonlar": "Opérations",
    "Araç Sorgulama": "Recherche de véhicule",
    "Şase No Giriniz": "Saisir le n° VIN",
    "Tamam": "OK",
    "Liman Giriş": "Entrée au port",
    "Ara": "Rechercher",
    "Operasyon İzleme": "Suivi des opérations",
    "Excel Toplu İşlemler": "Opérations Excel en masse",
    "Hasar Bildirimi": "Déclaration de dommage",
    "Gemi İşlemleri": "Opérations navire",
    "Stok İzleme": "Suivi du stock",
    "Hasar Açıklama": "Description du dommage",
    "Bölge": "Zone",
    "Bildiren Kişi": "Déclarant",
    "Hasar Görseli": "Photo du dommage",
    "Hasar Bildir": "Déclarer un dommage",
    "Listele": "Liste",
    "PDI Giriş": "Entrée PDI",
    "PDI Dönüş": "Retour PDI",
    "PDI Çıkış": "Sortie PDI",
    "Etiket Yazdır": "Imprimer l'étiquette",
    "PDI Yapılmayacak": "PDI non requis",
    "Rıhtım'a İade": "Retour au quai",
    "Hasarlıdan Çıkış": "Sortie de la zone endommagés",
    "Sevke Hazırlama": "Préparer pour l'expédition",
    "Yazıcı Seçimi": "Choix de l'imprimante",
    "Çalıştığınız Depo": "Votre entrepôt",
    "Kullanılan Yazıcı Seçiniz": "Choisir l'imprimante",
    "Kaydet": "Enregistrer",
    "Peron Kontrol": "Contrôle de quai",
    "Gemi Araç Giriş": "Entrée des véhicules du navire",
    "Toplam Stok": "Stock total",
    "Faturlanmış / Sevk Emri Olan": "Ordre facturé / expédié",
    "Faturalanmamış / Sevk Emri Olmayan": "Ordre non facturé / non expédié",
    "Blokajlı": "Bloqué",
    "Sevk Edilebilir Araç Sayısı": "Nombre de véhicules expédiables",
    "Depo": "Entrepôt",
    "Bayi Sevk": "Expédition concessionnaire",
    "Depolar Arası Transfer": "Transfert entre entrepôts",
    "Son 7 Gün Depo Çıkış Adetleri": "Sorties d'entrepôt des 7 derniers jours",
    "Grupaj Operasyonları": "Opérations de groupage",
    "Grupaj Operasyonları Detay": "Détail des opérations de groupage",
    "Depo Çıkış": " Sortie d'entrepôt",
    "Grupaj No Giriniz": "Saisir le n° de groupage",
    "Hasar Tarihi": "Date du dommage",
    "Hasar Bildirilen Bölge": "Zone du dommage",
    "İptal": "Annuler",
    "Faturalanmış / Sevk Emri Olan": "Ordre facturé / expédié",
    "equal": "Égal à",
    "greaterThan": "Supérieur à",
    "greaterThanOrEqual": "Supérieur ou égal à",
    "lessThan": "Inférieur à",
    "lessThanOrEqual": "Inférieur ou égal à",
    "notContains": "Ne contient pas",
    "notEqual": "Différent de",
    "startswith": "Commence par",
    "endsWith": "Se termine par",
    "between": "Entre",
    "contains": "Contient",
    "endswith": "Se termine par",
    "tümü": "(Tous)",
    "Filtrele": "Filtre",
    "Yüklemek İstediğiniz Excel Dosyasını seçiniz. Excel Şablonunu": "Veuillez sélectionner le fichier Excel à charger. Vous pouvez télécharger le modèle Excel",
    "buradan": "ici",
    "indirebilirsiniz": "à partir d'ici",
    "Excel Dosyası Yükle": "Charger le fichier Excel",
    "vehicleData cannot be nil": "vehicleData ne peut pas être vide",
    "chassisNo number is required": "Le numéro de châssis est obligatoire",
    "chassisNo number must be 17 characters": "Le numéro de châssis doit comporter 17 caractères",
    "user ID is required": "L'identifiant utilisateur est obligatoire",
    "type is required": "Le type est obligatoire",
    "data is required": "Les données sont obligatoires",
    "no vehicle found with chassis number": "Aucun véhicule trouvé avec ce numéro de châssis",
    "multiple vehicles found with chassis number": "Plusieurs véhicules trouvés avec ce numéro de châssis",
    "PDI order has not been issued for this vehicle": "Aucun ordre PDI n'a été émis pour ce véhicule",
    "Vehicle not found": "Véhicule introuvable",
    "Invalid vehicle status": "Statut du véhicule invalide",
    "PDI entry has already been processed for this vehicle": "L'entrée PDI a déjà été traitée pour ce véhicule",
    "Internal server error": "Erreur interne du serveur",
    "Yükleniyor": "Chargement",
    "PDI entry not found for this vehicle": "Entrée PDI introuvable pour ce véhicule",
    "PDI entry process not completed": "Le processus d'entrée PDI n'est pas terminé",
    "PDI exit already processed for this vehicle": "La sortie PDI a déjà été traitée pour ce véhicule",
    "multiple vehicles found with same chassis number": "plusieurs véhicules trouvés avec le même numéro de châssis",
    "PDI entry already processed for this vehicle": "L'entrée PDI a déjà été traitée pour ce véhicule",
    "invalid vehicle status": "statut du véhicule invalide",
    "vehicle not found": "véhicule introuvable. Veuillez vérifier le numéro VIN.",
    "Beklenmedik bir hata oluştu.": "Une erreur inattendue s'est produite.",
    "Invalid request format": "Format de requête invalide",
    "merge error: PDI status is already YENI": "Un ordre PDI actif existe déjà pour ce véhicule.",
    "failed to check vehicle existence: vehicle not found": "Véhicule introuvable",
    "merge error: PDI status is already IPTAL": "Un ordre PDI annulé existe déjà pour ce véhicule.",
    "Kullanıcı Yönetimi": "Gestion des utilisateurs",
    "Ad Soyad": "Nom Prénom",
    "Kullanıcı Adı": "Nom d'utilisateur",
    "Aktif": "Actif",
    "İşlem": "Action",
    "Yeni Kayıt": "Nouvel enregistrement",
    "Toplam": "Total",
    "Yeni Kayıt Formu": "Formulaire de nouvel enregistrement",
    "Kullanıcı Bilgileri": "Informations utilisateur",
    "Yetkilendirme": "Autorisation",
    "Yekilendirme": "Autorisation",
    "Lütfen Ad Soyad giriniz.": "Veuillez saisir le nom et le prénom.",
    "Cinsiyet": "Genre",
    "Cinsiyet Seçiniz": "Choisir le genre",
    "Lütfen Kullanıcı Adı giriniz.": "Veuillez saisir le nom d'utilisateur.",
    "Lütfen Email giriniz.": "Veuillez saisir l'e-mail.",
    "Sadece Görme Yetkisi": "Autorisation de consultation uniquement",
    "Sadece Ekleme Yetkisi": "Autorisation d'ajout uniquement",
    "Sadece Güncelleme Yetkisi": "Mise à jour uniquement",
    "Sadece Silme Yetkisi": "Autorisation de suppression uniquement",
    "Sadece Excel Export Yetkisi": "Autorisation d'export Excel uniquement",
    "Tüm Özel Rolleri Kaldır": "Retirer tous les rôles spéciaux",
    "Lütfen Kullanıcı seçiniz": "Veuillez sélectionner un utilisateur",
    "marked_roles": "*Les rôles marqués",
    "in_selected_role_group": "'Dans le groupe de rôles sélectionné'",
    "defined_roles": "sont des rôles définis. Les autres rôles sélectionnés sont ajoutés à la personne en tant que",
    "special_role": "'Rôle spécial'",
    "as_special_role": ".",
    "Yetki Grubu Adı": "Nom du groupe d'autorisations",
    "Rol Adı": "Nom du rôle",
    "Geri": "Retour",
    "Gruplamak için sütun başlığını buraya sürükleyin": "Faites glisser un titre de colonne ici pour grouper",
    "Bu sütuna göre grupla": "Grouper par cette colonne",
    "Devamı için buraya tıklayın": "Cliquez ici pour en savoir plus",
    "Grubu çöz": "Dégrouper",
    "Tüm grupları çöz": "Tout dégrouper",
    "Özel Roller": "Rôles spéciaux",
    "Yetki Grupları": "Groupes d'autorisations",
    "Şifre": "Mot de passe",
    "Şifre Tekrarı": "Répéter le mot de passe",
    "Lütfen Şifre giriniz": "Veuillez saisir le mot de passe",
    "Şifre belirlemeyecekseniz şifre alanlarını boş bırakınız.": "Si vous ne souhaitez pas définir de mot de passe, laissez les champs vides.",
    "Lütfen Şifre Tekrarı giriniz": "Veuillez répéter le mot de passe",
    "inactive_user_message": "L'e-mail saisi appartient à un utilisateur",
    "inactive_user": "inactif",
    "continue_message": "dans le système. Si vous souhaitez activer cet utilisateur et continuer, veuillez",
    "activate_user": "activer l'utilisateur",
    "or_different_email": "ou continuer avec une autre adresse e-mail.",
    "İleri": "Suivant",
    "Toplu Kullanıcı Yetki Grubu Atama": "Affectation de rôles en masse",
    "Kullanıcı Rol Yönetimi": "Gestion des rôles utilisateur",
    "Seçim": "Sélection",
    "Kullanıcı Yetki Grubu Atama Formu": "Formulaire d'affectation de rôles",
    "Yetki Grubu Güncelleme Formu": "Formulaire de mise à jour du groupe d'autorisations",
    "Yetki Grup Yönetimi": "Gestion des groupes d'autorisations",
    "Yetki Grubu Oluştur": "Créer un groupe d'autorisations",
    "Grup Bilgileri": "Informations du groupe",
    "Yeni Yetki Grubu Oluşturma Formu": "Formulaire de création d'un groupe d'autorisations",
    "Roller": "Rôles",
    "17 karakterli şase numarası giriniz": "Veuillez saisir un numéro VIN de 17 caractères",
    "Lütfen hasar açıklaması giriniz": "Veuillez saisir une description du dommage",
    "please": "Veuillez",
    "enter": "saisir",
    "Lütfen Adres Tarifi Giriniz": "Veuillez saisir la description de l'adresse",
    "Lütfen Adres Seçiniz": "Veuillez sélectionner une adresse",
    "Depo Tanım": "Définition d'entrepôt",
    "Depo Kodu": "Code entrepôt",
    "Depo Kısa Adı": "Nom court de l'entrepôt",
    "Kapasite": "Capacité",
    "Vergi Dairesi": "Centre des impôts",
    "Vergi No": "N° fiscal",
    "Depo Ekle": "Ajouter un entrepôt",
    "Depo Adı": "Nom de l'entrepôt",
    "Ekle": "Ajouter",
    "Boş Olamaz": "Ne peut pas être vide",
    "Depo Silme Formu": "Formulaire de suppression d'entrepôt",
    "Depo Silme Başarısız": "Échec de la suppression de l'entrepôt",
    "Depo Silme Başarılı": "Entrepôt supprimé",
    "warehouse not found or already deleted with id": "Entrepôt introuvable ou déjà supprimé",
    "Depo Ekleme Başarısız": "Échec de l'ajout de l'entrepôt",
    "Depo Ekleme Başarılı": "Entrepôt ajouté",
    "Depo Güncelleme Başarısız": "Échec de la mise à jour de l'entrepôt",
    "Depo Güncelleme Başarılı": "Entrepôt mis à jour",
    "cannot create zone in inactive warehouse": "Impossible de créer une zone dans un entrepôt inactif",
    "Adı": "Nom",
    "Geçerli": "Valide",
    "Bölge Kodu": "Code zone",
    "Bölge Adı": "Nom de la zone",
    "Sevke Açık Bölge": "Zone ouverte à l'expédition",
    "Bölge Tanım": "Définition de zone",
    "Bölgeden Çıkışta Form Yazdır": "Imprimer un formulaire à la sortie de la zone",
    "Bölge Ekle": "Ajouter une zone",
    "Depo Tanımları": "Définitions des entrepôts",
    "Bölge Tanımları": "Définitions des zones",
    " adet kayıt başarılı bir şekilde eklendi.": " enregistrements ajoutés avec succès.",
    "adet başarılı": "réussi",
    "adet hatalı kayıt": "enregistrement incorrect",
    "araç tanımlandı": "véhicule défini",
    "araç güncellendi": "véhicule mis à jour",
    "araçta hata oluştu": "erreur sur le véhicule",
    "Super Admin en kapsamlı roldür. Ek role ihtiyaç yok.": "Super Admin est le rôle le plus complet. Aucun rôle supplémentaire n'est nécessaire.",
    "Girmiş olduğunuz Email sistem üzerinde aktif bir kullanıcıya aittir. Lütfen farklı bir Email giriniz.": "L'e-mail saisi appartient à un utilisateur actif. Veuillez saisir un autre e-mail.",
    "failed to check chassis number: vehicle not found": "Véhicule introuvable",
    "Adres Değiştirme": "Changer l'adresse",
    "Kriterler": "Critère",
    "Koordiant": "Coordonnée",
    "Yön": "Direction",
    "Sıra": "Rangée",
    "Bu koordinat ve yön için belirtilen sıra aralığı zaten mevcut": "La plage de séquence indiquée pour cette coordonnée et cette direction existe déjà",
    "Yerinde Adresleme": "Adressage sur place",
    "Ship unload has already been processed for this vehicle": "Le déchargement du navire a déjà été traité pour ce véhicule",
    "Vehicle must be of type 'ithal'": "Le véhicule doit être de type « importé »",
    "EMPTY": "VIDE",
    "FULL": "PLEIN",
    "PARTIALLY_FULL": "PARTIELLEMENT PLEIN",
    "OUT OF USE": "HORS SERVICE",
    "PDI order has not been issued": "Aucun ordre PDI n'a été émis",
    "{address} adresi kullanımda olduğu için boş duruma ayarlanamaz": "Impossible de vider l'adresse {address} : adresse utilisée",
    "updateFailed": "Échec de la mise à jour de l'adresse",
    "updateSuccess": "Adresse mise à jour",
    "selectAddress": "Veuillez sélectionner une adresse",
    "boş olarak ayarlanamaz: Adres kullanımda": "Impossible de vider : adresse utilisée",
    "Adres": "Adresse",
    "ship unload already processed": "Déchargement du navire déjà traité",
    "vehicle is already domestic (milli)": "Le véhicule est déjà dédouané (milli)",
    "PASSENGER": "TOURISME",
    "COMMERCIAL": "UTILITAIRE",
    "HEAVY_COMMERCIAL": "POIDS LOURD",
    "location": "Emplacement",
    "dealer_code": "Code concessionnaire",
    "company_title": "Raison sociale",
    "group_company_title": "Raison sociale du groupe",
    "brand_id": "Marque",
    "address_definition": "Définition d'adresse",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "phone1": "Téléphone 1",
    "distance": "Distance",
    "group_region_id": "Région du groupe",
    "standard_address_id": "Adresse standard",
    "tax_office": "Centre des impôts",
    "tax_number": "Numéro fiscal",
    "coordinates": "Coordonnées",
    "phone": "Téléphone",
    "excel_data": "Données Excel",
    "aladin_code_name": "Code/Nom Aladin",
    "aladin_code": "Code Aladin",
    "aladin_name": "Nom Aladin",
    "tax_info": "Informations fiscales",
    "authorized_info": "Informations du responsable",
    "email": "Informations e-mail",
    "special_notes": "Notes particulières",
    "is_active": "Actif",
    "is_warehouse": "Définition d'entrepôt",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "dealer_form": "Fiche concessionnaire",
    "field_required": "{field} est obligatoire",
    "error_loading_data": "Erreur lors du chargement des données",
    "fill_required_fields": "Veuillez remplir les champs obligatoires",
    "record_created": "Enregistrement créé",
    "record_updated": "Enregistrement mis à jour",
    "error_occurred": "Une erreur s'est produite",
    "No dock permit found for this chassis": "Aucun permis de quai trouvé pour ce châssis",
    "vehicle type: ithal, antrepo: false": "Les véhicules importés (non dédouanés) ne peuvent sortir que s'ils se trouvent dans la zone de l'entrepôt. Les véhicules hors de cette zone ne peuvent pas sortir.",
    "failed to get groupage details: vehicle not found with the given groupage no": "Aucun véhicule trouvé pour ce n° de groupage",
    "Depo Yönetimi": "Gestion des entrepôts",
    "Adresteki Araçları Boşalt": "Décharger les véhicules à l'adresse",
    "Park Şöförleri": "Chauffeurs de parc",
    "Emir Tanımlama": "Définition des ordres",
    "Araç Yönetimi": "Gestion des véhicules",
    "Sevkiyat Tanımları": "Définitions d'expédition",
    "Taseron Firmalar": "Sous-traitants",
    "Sevkiyat Yerleri": "Lieux d'expédition",
    "Sevk Bölgeleri": "Régions d'expédition",
    "Adres Tanımları": "Définitions d'adresses",
    "İl Tanımları": "Définitions des provinces",
    "İlçe Tanımları": "Définitions des districts",
    "Sevkiyat Tipi": "Type d'expédition",
    "Rota Tanımları": "Définitions des itinéraires",
    "Sevkiyat KM Bilgileri": "Kilométrage des expéditions",
    "Araç Markaları": "Marques de véhicules",
    "Model Tanımları": "Définitions des modèles",
    "Renk Tanımları": "Définitions des couleurs",
    "Tanımlamalar": "Définitions",
    "Veri Yükleme": "Chargement de données",
    "Şase Tanımlama": "Définition VIN",
    "Şase Uyarı Yükleme": "Chargement des alertes VIN",
    "Gemi Tahliye Bilgisi": "Informations de déchargement du navire",
    "Gümrüklendi Bilgisi": "Informations douanières",
    "PDI Emir Girişi": "Saisie des ordres PDI",
    "Fatura Verileri": "Données de facturation",
    "Önceliklendirme": "Priorisation",
    "Blokaj/Sevk Emri": "Ordre de blocage / d'expédition",
    "Manuel Sevk Emri": "Ordre d'expédition manuel",
    "Tekli Grupaj Tır Eşleme": "Affectation camion à un groupage",
    "Gemi Tahliye": "Déchargement du navire",
    "Gümrüklü Saha Çıkış": "Sortie de zone sous douane",
    "Sevk Alanına Transfer": "Transfert vers la zone d'expédition",
    "Depolar Arası Transfer Emri": "Ordre de transfert entre entrepôts",
    "Depolar Arası Transfer İzleme": "Suivi des transferts entre entrepôts",
    "Grupaj Hazırlama": "Préparation du groupage",
    "Grupaj İşlemleri": "Opérations de groupage",
    "the order to unload the ship must be given first": "Le navire doit d'abord être déchargé",
    "vehicle in antrepo zone but has no PDI order": "Véhicule en zone sous douane sans ordre PDI",
    "chassis not found": "Châssis introuvable",
    "failed to check vehicle gorupage status and address: vehicle in groupage": "Véhicule dans un groupage",
    "failed to get chassis history": "Impossible d'obtenir l'historique du châssis",
    "no history found for chassis number": "Aucun historique pour ce numéro de châssis",
    "invalid chassis number length": "Longueur du numéro de châssis invalide",
    "must be 17 characters": "doit comporter 17 caractères",
    "COMPLETED": "TERMINÉ",
    "WAITING": "EN ATTENTE",
    "no suitable address found": "Aucune adresse adaptée trouvée",
    "failed to assignToStockArea: no suitable address found": "Aucune adresse adaptée trouvée",
    "öncelikle tır onayı işlemi yapılmalıdır": "La validation du camion doit d'abord être effectuée",
    "failed to parse address operations": "Impossible d'analyser les opérations d'adresse",
    "unexpected end of JSON input": "Fin inattendue des données JSON",
    "vehicle is active": "Le véhicule est actif dans l'entrepôt",
    "from_warehouse_id": "Entrepôt d'origine",
    "to_warehouse_id": "Entrepôt de destination",
    "transfer_date": "Date du transfert",
    "order_id": "ID de l'ordre",
    "customs_clearance.clearance_date:": "Date de dédouanement",
    "customs_clearance.clearance_date": "Date de dédouanement",
    "ship_unload.unload_date": "Date de déchargement du navire",
    "dock_permit.permit_date": "Date du permis de quai",
    "failed to get vehicle: vehicle not found": "Véhicule introuvable",
    "vehicle has no current address assignment": "Le véhicule n'a pas d'adresse actuelle",
    "failed to get reception zone: failed to get zone: no rows in result set": "Cet entrepôt n'a pas de zone « Réception ». Veuillez vérifier.",
    "return.return_date": "Date de retour",
    "failed to check vehicle: vehicle not found": "Véhicule introuvable",
    "vehicle is suspended": "Le véhicule est en zone de réception et n'est pas défini dans le système",
    "chassis need to be customs clearanced": "Le châssis doit être dédouané",
    "data SHIP_UNLOAD warehouse_code error: failed to assign chassis to ship area: no rows in result set": "Le véhicule est en zone de déchargement du navire et n'est pas défini dans le système",
    "vehicle has already an order with status waiting": "Le véhicule a déjà un ordre en attente",
    "no chassis found with number": "Aucun châssis trouvé avec ce numéro",
    "vehicle is in groupage": "Le véhicule est dans un groupage",
    "failed to assign chassis to ship area": "Impossible d'affecter le châssis à la zone navire",
    "no rows in result set": "Aucune ligne dans le résultat",
    "warehouse assignment error: failed to assign chassis to ship area: no rows in result set": "Erreur d'affectation à l'entrepôt : impossible d'affecter le châssis à la zone navire : aucune ligne dans le résultat",
    "failed to check requesting dealer: order is not from the requested dealer": "Échec du contrôle du concessionnaire demandeur : l'ordre ne provient pas du concessionnaire demandé",
    "failed to check requesting dealer: order is not from the requested dealer:": "Échec du contrôle du concessionnaire demandeur : l'ordre ne provient pas du concessionnaire demandé",
    "warehouse assignment error": "Erreur d'affectation d'entrepôt",
    "failed to check requesting dealer": "Échec du contrôle du concessionnaire demandeur",
    "order is not from the requested dealer": "L'ordre ne provient pas du concessionnaire demandé",
    "error.invalid_client_code": "Code concessionnaire invalide",
    "PDI status is already YENİ": "Le véhicule a un ordre PDI.",
    "merge error": "Erreur de fusion",
    "The vehicle's dock exit must be ensured": "La sortie de quai du véhicule doit être effectuée",
    "domestic vehicles are not allowed for dock enter": "Les véhicules dédouanés ne sont pas autorisés à entrer au quai",
    "failed to get vehicle data: vehicle not found": "Impossible d'obtenir les données du véhicule : véhicule introuvable",
    "no invoice or shipping order": "Aucune facture ni ordre d'expédition",
    "tarih is required and cannot be empty": "La date est obligatoire",
    "failed to transform data": "Erreur de transformation des données",
    "vehicle already has dock permit": "Le véhicule a déjà un permis de quai",
    "updated": "Mis à jour",
    "created": "Créé"
};

export default frMessages;
